angular.module('picmonicpublic').controller('relatedFactsController', ['$scope', function($scope){
        $scope.$parent.seen.relatedfacts = 1;
    }]);